/*=========================================================================================
  File Name: this.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
   
==========================================================================================*/

// import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/plugins/themeConfig.js"
import colors from "@/plugins/themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "大卫", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status      : "online",
  userRole    : "admin"
}

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}
const localSetting = JSON.parse(localStorage.getItem('settings') || '{}')

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
// const getUserInfo = () => {
//   let userInfo = {}

//   // Update property in user
//   Object.keys(userDefaults).forEach((key) => {
//     // If property is defined in localStorage => Use that
//     userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
//   })

//   // Include properties from localStorage
//   Object.keys(userInfoLocalStorage).forEach((key) => {
//     if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
//   })

//   return userInfo
// }

const navMenuItems = [
  // 首页导航

  // 应用菜单


  // 演示页面
  // {
  //   url: '/empty',
  //   name: "空白页面",
  //   tag: "2",
  //   tagColor: "warning",
  //   icon: "HomeIcon",
  //   bookmark: true
  // },
  {
    url: '/order/list',
    name: "订单管理",
    icon: "DatabaseIcon",
    bookmark: true,
  },
  {
    url: '/product/list',
    name: "商品管理",
    icon: "BriefcaseIcon",
    bookmark: true,
  },
  {
    url: '/customer/list',
    name: "客户管理",
    icon: "MehIcon",
    bookmark: true,
  },
  {
    rule: 'admin',
    name: "用户管理",
    icon: "UsersIcon",
    bookmark: true,
    submenu: [
      {
        url: '/user/list/admin',
        slug: 'user-admin',
        name: "管理员列表",
      },
      {
        url: '/user/list/channel',
        slug: 'user-channel',
        name: "渠道商列表",
      },
      {
        url: '/user/list/user',
        slug: 'user-user',
        name: "普通用户",
      },
    ]
  },
  {
    url: '/pages/setting',
    slug: 'ucenter-setting',
    icon: "SettingsIcon",
    bookmark: true,
    name: "用户设置",
  },
  {
    url: '/pages/price',
    slug: 'page-price',
    icon: "SettingsIcon",
    bookmark: true,
    name: "价格设置",
  },

]

export const siteinfo = {
  name: '锐视溯源',
  logo: require('@/assets/images/logo/logo.png'),
}

const state = {
  isVerticalNavMenuActive: localSetting.isVerticalNavMenuActive || true,
  mainLayoutType: localSetting.mainLayoutType || themeConfig.mainLayoutType || "vertical",
  reduceButton: localSetting.reduceButton || themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: localSetting.verticalNavMenuWidth || "default",
  verticalNavMenuItemsMin: localSetting.verticalNavMenuItemsMin || false,
  theme: localSetting.theme || themeConfig.theme || "light",
  themePrimaryColor: localSetting.themePrimaryColor || colors.primary,
  navbarType: localSetting.navbarType || themeConfig.navbarType,
  navbarColor: localSetting.navbarColor || themeConfig.navbarColor,
  footerType: localSetting.footerType || themeConfig.footerType,
  routerTransition: localSetting.routerTransition || themeConfig.routerTransition,
  hideScrollToTop: localSetting.hideScrollToTop || themeConfig.hideScrollToTop,
  disableThemeTour: localSetting.disableThemeTour || themeConfig.disableThemeTour,
  // AppActiveUser           : getUserInfo(),
  bodyOverlay             : false,
  scrollY                 : 0,
  // starredPages: starredPages, // 快捷方式

  navMenuItems,
  windowWidth: null,
  // logo: require('@/assets/images/logo/logo.png'),
  dict: {},
  site: siteinfo,
}

export default state
